/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 7
// module chunks = 1